// removed by extract-text-webpack-plugin
module.exports = {"meta":"'{\"e\":\".home-hero\",\"f\":[]}'"};